import React from "react";
import { Link } from "react-router-dom";
import { BRAND } from "../../lib/brand";

export default function OnboardingLayout({ children, agencyName = "" }) {
  const year = new Date().getFullYear();

  return (
    <div className="agent-onboarding-page min-vh-100 bg-neutral-50 d-flex flex-column">
      <header className="bg-white border-bottom">
        <div className="container py-12 d-flex align-items-center justify-content-between gap-3">
          <Link to="/onboarding" className="d-inline-flex align-items-center">
            <img src={BRAND.logo} alt={BRAND.name} className="agent-onboarding-logo" />
          </Link>
          <div className="text-end min-w-0">
            {agencyName ? (
              <>
                <div className="fw-semibold text-truncate">{agencyName}</div>
                <div className="text-secondary-light text-xs">Agency onboarding</div>
              </>
            ) : (
              <span className="text-secondary-light text-sm">Agency onboarding</span>
            )}
          </div>
        </div>
      </header>
      <main className="container py-24 py-lg-32 flex-grow-1">
        <div className="agent-onboarding-shell w-100">{children}</div>
      </main>
      <footer className="agent-onboarding-footer mt-auto">
        <div className="container py-16 d-flex flex-wrap align-items-center justify-content-between gap-2">
          <p className="mb-0 text-secondary small">&copy; {year} {BRAND.name}. All Rights Reserved.</p>
          <p className="mb-0 text-secondary small">Powered by Way 2 Websoft Technologies Pvt Ltd</p>
        </div>
      </footer>
    </div>
  );
}
